// Docs: https://wiki.guildwars2.com/wiki/API:2

const BASE_URL = "https://api.guildwars2.com/v2";
const COMMERCE_PRICES_ENDPOINT = "commerce/prices";
const MAX_IDS_PER_REQUEST = 150;

function toValidIds(ids = []) {
	return [...new Set(
		ids
			.map((id) => Number(id))
			.filter((id) => Number.isFinite(id) && id > 0),
	)];
}

function chunkIds(ids, chunkSize) {
	const chunks = [];
	for (let i = 0; i < ids.length; i += chunkSize) {
		chunks.push(ids.slice(i, i + chunkSize));
	}
	return chunks;
}

async function fetchJson(url) {
	const response = await fetch(url);
	if (!response.ok) {
		const text = await response.text();
		throw new Error(text || `GW2 API request failed (${response.status})`);
	}
	return response.json();
}

function normalizePriceResult(payload) {
	if (!payload) return [];
	if (Array.isArray(payload)) return payload;
	if (typeof payload === "object" && payload.id != null) return [payload];
	return [];
}

export async function getCommercePricesByIds(ids = []) {
	const validIds = toValidIds(ids);
	if (!validIds.length) return [];

	const chunks = chunkIds(validIds, MAX_IDS_PER_REQUEST);
	const responses = await Promise.all(
		chunks.map((chunk) => {
			const idsParam = chunk.join(",");
			const url = `${BASE_URL}/${COMMERCE_PRICES_ENDPOINT}?ids=${encodeURIComponent(idsParam)}`;
			return fetchJson(url);
		}),
	);

	return responses.flatMap((payload) => normalizePriceResult(payload));
}

export async function getCommercePrice(itemId) {
	const id = Number(itemId);
	if (!Number.isFinite(id) || id <= 0) return null;

	const url = `${BASE_URL}/${COMMERCE_PRICES_ENDPOINT}/${id}`;
	const payload = await fetchJson(url);
	return payload || null;
}

export async function enrichItemsWithTradingPostPrices(items = []) {
	if (!Array.isArray(items) || !items.length) return [];

	const ids = items.map((item) => item?.id);

	try {
		const prices = await getCommercePricesByIds(ids);
		const priceById = new Map(
			prices.map((price) => [
				String(price.id),
				{
					tp_whitelisted: Boolean(price.whitelisted),
					tp_buy_price: Number(price?.buys?.unit_price) || 0,
					tp_buy_quantity: Number(price?.buys?.quantity) || 0,
					tp_sell_price: Number(price?.sells?.unit_price) || 0,
					tp_sell_quantity: Number(price?.sells?.quantity) || 0,
				},
			]),
		);

		return items.map((item) => {
			const pricing = priceById.get(String(item?.id));
			return pricing ? { ...item, ...pricing } : item;
		});
	} catch (error) {
		console.error("Failed to enrich items with trading post prices", error);
		return items;
	}
}

